define(["./nodeCommandsModule"], function (nodeCommandModule) {
    "use strict";

    return nodeCommandModule.service("nodeCommandViewTripArrangement", ["arrangementViewerModal", function (arrangementViewerModal) {
        return function (selection) {
            return arrangementViewerModal.forTripWithAutomaticContext(selection[0].id);
        };
    }]);
});